module.exports = __webpack_public_path__ + "static/media/AddCardIcon.eb1d24d3.svg";